import { en } from '../i18n/translations/en'
import { uk } from '../i18n/translations/uk'

function resolveLanguage(): 'en' | 'uk' {
  const lang = typeof navigator !== 'undefined' ? navigator.language : ''
  if (lang.toLowerCase().startsWith('en')) {
    return 'en'
  }
  return 'uk'
}

export function SentryErrorFallback() {
  const t = resolveLanguage() === 'en' ? en : uk
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <p>{t.common.errors.unexpected}</p>
    </div>
  )
}
